module.exports = __webpack_public_path__ + "img/link.b1bee84.svg";